/** Pre-logout inactivity warning. Only the explicit button resets the
 * idle timer — passive mouse movement no longer counts at this stage. */
import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../ui/dialog';
import { Timer } from '@phosphor-icons/react';

export const IdleWarningDialog = ({ open, secondsLeft, onStay }) => {
  const mm = Math.floor(secondsLeft / 60);
  const ss = String(secondsLeft % 60).padStart(2, '0');
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-sm [&>button]:hidden" data-testid="idle-warning-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Timer size={20} className="text-amber-600" weight="duotone" />
            Still there?
          </DialogTitle>
          <DialogDescription>
            For security, you will be signed out after 15 minutes of inactivity.
          </DialogDescription>
        </DialogHeader>
        <p className="text-3xl font-bold text-slate-900 text-center font-mono" data-testid="idle-warning-countdown">
          {mm}:{ss}
        </p>
        <DialogFooter>
          <Button className="w-full bg-indigo-900 hover:bg-indigo-800" onClick={onStay} data-testid="idle-stay-signed-in-btn">
            Stay signed in
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default IdleWarningDialog;
